<template>
  <div>
    <pop-modal :visible="visible" title="发票作废" :width="1280" :height="100" @cancel="handelCancel">
      <div class="wrap">
        <div class="wrap-header">
          <div class="option-btn">
            <div class="search">
              <a-input
                value=""
                placeholder="请输入客户编码、名称、税号等信息"
                @pressEnter="search()"
                @change="search()"
              >
                <a-icon slot="prefix" type="search" />
              </a-input>
              <a-button type="primary" @click="search()"> 查询 </a-button>
            </div>
            <div class="edit-group">
              <a-button type="primary" ghost @click="update()"> 作废 </a-button>
              <a-button type="primary" ghost @click="detail()"> 查看明细 </a-button>
            </div>
          </div>
        </div>
        <div class="wrap-content">
          <m-table
            :row-selection="{
              selectedRowKeys: selectedRowKeys,
              onChange: onSelectChange,
              onDbClick: isModule && onDbClick,
            }"
            :columns="columns"
            :data-source="listOfData"
            :pagination="false"
            :filterMultiple="true"
            @changeShowCount="changeShowCount"
          ></m-table>
        </div>
        <div class="wrap-footer">
          <div class="left">
            <div>
              <span>【本页统计】</span>
              <span>合计金额：</span>
              <span>合计税额：</span>
              <span>价税合计：</span>
            </div>
            <div>
              <span>【本页统计】</span>
              <span>合计金额：</span>
              <span>合计税额：</span>
              <span>价税合计：</span>
            </div>
          </div>
          <div class="right">
            <select name="" id="" v-model="pages.showCount" @change="changeShowCount()">
              <option :value="item" v-for="(item, index) in showCountList" :key="index">{{ item }}条/页</option>
            </select>
            <div class="inline-block">
              <span>共 {{ pages.totalPage }}页</span>
            </div>
            <div style="margin-top: 5px">
              <a-button type="primary" ghost @click="pro()" class="mr-1"> 上一页 </a-button>
              <a-button type="primary" ghost @click="next()" class="mr-1"> 下一页 </a-button>
              <span>跳转至 <input type="text" style="width: 50px" v-model="pages.currentPage" /> 页</span>
            </div>
          </div>
        </div>
      </div>
    </pop-modal>
    <invoice ref="invoiceForm"></invoice>
  </div>
</template>

<script>
import Urls from '@/utils/globel.js'
import { parseParam } from '@/utils/util.js'
import { mapGetters, mapActions } from 'vuex'
import invoice from '@/views/invoice.vue'
import moment from 'moment'
import 'moment/locale/zh-cn'
export default {
  components: {
    invoice,
  },
  data() {
    return {
      visible: false,
      labelCol: {
        xs: { span: 24 },
        sm: { span: 7 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 13 },
      },
      searchParam: {
        startDate: moment(),
        endDate: moment(),
      },
      isEdit: false,
      value: '',
      selectedRowKeys: [],
      columns: [
        {
          title: '发票种类',
          dataIndex: 'taxClass',
          width: 150,
          customRender: (v) => (v === '0' ? '专用发票' : v === '1' ? '普通发票' : '电子普通发票'),
        },
        {
          title: '发票代码',
          dataIndex: 'taxBillCode',
          width: 150,
        },
        {
          title: '发票号码',
          dataIndex: 'taxBillNo',
          width: 150,
        },
        {
          title: '购方名称',
          dataIndex: 'buyerName',
          width: 150,
        },
        {
          title: '购方税号',
          dataIndex: 'buyerTaxpayerId',
          width: 150,
        },
        {
          title: '开票日期',
          dataIndex: 'taxBillDate',
          width: 150,
          customRender: (v) => moment(v).format('YYYY-MM-DD'),
        },
        {
          title: '主要商品名称',
          dataIndex: 'goodsName',
          width: 150,
        },
        {
          title: '备注',
          dataIndex: 'remark',
          width: 150,
        },
        {
          title: '报送状态',
          dataIndex: 'remark',
          width: 150,
          customRender: (v) => (v === 'Y' ? '已报送' : '未报送'),
        },
        {
          title: '报送日志',
          dataIndex: '',
          width: 150,
        },
        {
          title: '合计税额',
          dataIndex: 'totalTaxPay',
          width: 150,
          //   customRender:()=>{number:'1.2-2'}
        },
        {
          title: '清单标志',
          dataIndex: 'isMenu',
          width: 150,
          customRender: (v) => (v === 'Y' ? '是' : '否'),
        },
        {
          title: '打印标志',
          dataIndex: 'isPrint',
          width: 150,
          customRender: (v) => (v === 'Y' ? '是' : '否'),
        },
        {
          title: '作废标志',
          dataIndex: 'isVoid',
          width: 150,
          customRender: (v) => (v === 'Y' ? '是' : '否'),
        },
        {
          title: '发票状态',
          dataIndex: '',
          width: 150,
        },
        {
          title: '作废日期',
          dataIndex: 'voidDate',
          width: 150,
          customRender: (v) => moment(v).format('YYYY-MM-DD'),
        },
        {
          title: '开票人',
          dataIndex: 'drawer',
          width: 150,
        },
        {
          title: '收款人',
          dataIndex: 'payee',
          width: 150,
        },
        {
          title: '复核人',
          dataIndex: 'rechecker',
          width: 150,
        },
      ],
      pages: {
        total: 0,
        pageIndex: 1,
        totalPage: 0,
        showCount: 10,
        currentPage: 1,
        index: -1,
      },
      showCountList: [10, 20, 30, 50, 100, 500, 1000],
      listOfData: [],
      // 客户编码新增编辑
      kehu: {
        id: '',
        name: '',
        code: '',
        taxPayerId: '',
        shortName: '',
        mailAddr: '',
        address: '',
        accounts: '',
        remark: '',
      },
      isModule: false,
    }
  },
  created() {},
  computed: {
    ...mapGetters('practice', ['ENTERPRISE']),
  },
  methods: {
    show() {
      this.visible = true
      this.getInvoiceList()
    },
    async getInvoiceList() {
      const params = parseParam({
        showCount: this.pages.showCount,
        currentPage: this.pages.currentPage,
        isabolish: 1,
      })
      const res = await this.$http.get(`${Urls.getInvoiceList}&${params}`)
      if (res.statusCode === '200') {
        this.listOfData = res.data
        this.pages.total = res.total
        this.pages.totalPage = res.totalPage
      }
    },
    handelCancel() {
      this.visible = false
    },
    search() {
      this.getInvoiceList()
    },
    startChange(date, dateString) {
      this.searchParam.startDate = date
    },
    endChange(date, dateString) {
      this.searchParam.endDate = date
    },
    pro() {
      if (this.pages.currentPage > 1) {
        this.pages.currentPage--
        this.getInvoiceList()
      }
    },
    next() {
      if (this.pages.currentPage < this.pages.totalPage) {
        this.pages.currentPage++
        this.getInvoiceList()
      }
    },
    changeShowCount(val) {
      this.pages.showCount = val
      this.pages.currentPage = 1
      this.getInvoiceList()
    },
    test() {},
    // 查看明细
    detail() {
      if (this.selectedRowKeys.length) {
        this.seeInvoiceDetail()
      }
    },
    async seeInvoiceDetail() {
      const params = parseParam({
        invoiceId: this.selectedRowKeys[0].id,
      })
      const res = await this.$http.get(`${Urls.seeInvoiceDetail}&${params}`)
      if (res.statusCode === '200') {
        const data = res.data
        data.domainName = this.ENTERPRISE.domainName
        this.taxClass = res.data.taxClass
        const params = {
          detail: res.data,
          studentReportTaxBList: res.data.studentReportTaxBList,
        }
        this.$refs.invoiceForm.show(params)
      }
    },
    // 发票作废 返回modules 重新上传新的做题记录到oss
    update() {
      // this.updateInvoice()
      if (this.selectedRowKeys[0].isVoid === 'Y') {
        this.$error({
          title: '提示',
          content: '该发票已作废，无需再次作废',
        })
        return
      }
      if (this.selectedRowKeys.length) {
        this.updateInvoice()
      } else {
        this.$error({
          title: '提示',
          content: '请先选择一项',
        })
      }
    },
    async updateInvoice() {
      let voidDate = new Date(this.selectedRowKeys[0].taxBillDate).getTime() + 5 * 24 * 60 * 60 * 1000
      voidDate = moment(voidDate).format('YYYY-MM-DD')
      const params = parseParam({
        invoiceId: this.selectedRowKeys[0].id,
        isVoid: 'Y', // 作废：N，不作废：Y
        voidDate: voidDate,
      })
      const res = await this.$http.get(`${Urls.updateInvoice}&${params}`)
      if (res) {
        this.$info({
          title: '提示',
          content: '本张发票已作废',
        })
        this.getInvoiceList()
        this.uploadTestByOSS({ res, isFinish: '1' })
      }
    },
    onDbClick(selectedRowKeys) {
      console.log(selectedRowKeys)
    },
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys
    },
    ...mapActions('practice', ['uploadTestByOSS']),
  },
}
</script>

<style lang="less" scoped>
.wrap {
  color: #000;
  display: flex;
  flex-direction: column;
  height: 100%;
}
.wrap-header {
  padding: 10px;
  > div {
    padding: 5px 0;
  }
  .divider {
    display: inline-block;
    border: 1px solid;
    border-radius: 5px;
    position: relative;
    width: 50%;
    .divider-title {
      position: absolute;
      background: #fff;
      top: -10px;
      left: 10px;
    }
    .divider-content {
      display: flex;
      align-items: center;
      justify-content: space-around;
      .cont-check {
        display: inline-block;
        padding: 10px 15px 5px;
        width: 20%;
      }
    }
  }
  .option-btn {
    display: flex;
    justify-content: space-between;
    .edit-group {
      button {
        margin-right: 10px;
      }
    }
    .search {
      display: flex;
      button {
        margin-left: 10px;
      }
    }
  }
}
.wrap-content {
  display: flex;
  height: 100%;
  flex: 1;
}
.wrap-footer {
  height: 100px;
  display: flex;
  align-items: center;
  padding: 5px;
  .left {
    flex: 1;
    > div {
      padding: 5px 0;
    }
  }
}
</style>
